"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cisano-bergamasco": {
    "938bea66": [{
      "hkey": "000674b8",
      "slug": "san-gregorio-ca-gandolfi",
      "name": "San Gregorio-Ca' Gandolfi",
      "primary": true,
      "skipSearch": false
    }],
    "san-gregorio": [{
      "hkey": "000674b8",
      "slug": "san-gregorio-ca-gandolfi",
      "name": "San Gregorio-Ca' Gandolfi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c469c484": [{
      "hkey": "5b7f3c7e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "villasola": [{
      "hkey": "5b7f3c7e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cisano-bergamasco"
    }]
  }
};
exports["default"] = _default;